<template>
    <div class="container flex h-100">

        <!-- tooliaba logo -->
        <HeaderItem link="/">
            <a class="flex items-center pr3 pointer"><img src="@/assets/img/logos/tooliaba_logo.svg"></a>
        </HeaderItem>

        <!-- rent a tool -->
        <HeaderDropdown class="bl br b--dark-gray" :menuVisible="searchMenu" @menuChanged="searchMenu = $event; onMenuChanged()">
            <template  slot="item">
                <img class="pr2" src="@/assets/img/icon_search_black.svg" v-if="searchMenu">
                <img class="pr2" src="@/assets/img/icon_search_white.svg" v-if="!searchMenu">
                <h6>Rent a Tool</h6>
            </template>
            <template slot="menu">
                <NavSearch />
            </template>
        </HeaderDropdown>

        <!-- more -->
        <HeaderDropdown :menuVisible="moreMenu" @menuChanged="moreMenu = $event; onMenuChanged()">
            <template slot="item">
                <h6>More</h6>
                <span class="light-gray pl1">&#x25BE;</span>
            </template>
            <template slot="menu">
                <ListItem link="error-page">Insurance</ListItem>
                <ListItem link="error-page">Reviews</ListItem>
                <ListItem link="error-page">Help & Support</ListItem>
            </template>
        </HeaderDropdown>
        
        <div class="ml-auto flex">

            <!-- dashboard -->
            <HeaderItem v-if="$auth.check()" link="/dashboard" class="ml-auto">Dashboard</HeaderItem>

            <!-- inbox -->
            <HeaderItem v-if="$auth.check()" link="/inbox">Inbox
                <Pill v-if="unreadCount" :count="unreadCount"/>
            </HeaderItem>

            <!-- list my tools -->
            <HeaderItem link="/listing-start">List My Tools</HeaderItem>

            <!-- avatar -->
            <HeaderDropdown :menuVisible="profileMenu" @menuChanged="profileMenu = $event; onMenuChanged()" :align-left='false' v-if="$auth.check()">
                <template slot="item">
                    <img style="width:50px;" src="@/assets/img/avatars/avatar_1.svg">
                    <span class="light-gray pl1">&#x25BE;</span>
                </template>
                <template slot="menu">
                    <DesktopAuthenticatedMenu />
                </template>
            </HeaderDropdown>

            <!-- login menu -->
            <HeaderDropdown :menuVisible="profileMenu" @menuChanged="profileMenu = $event; onMenuChanged()" :align-left='false' colorstyle='login' v-else>
                <template slot="item">
                    <h6 v-if="!profileMenu">Log In</h6>
                    <img v-if="profileMenu" class="w1" src="@/assets/img/icon_x.svg">
                </template>
                <template slot="menu">
                    <DesktopMainMenu />
                </template>
            </HeaderDropdown>
        </div>

    </div>
</template>

<script>
import HeaderItem from '@/components/header/HeaderItem.vue';
import HeaderDropdown from '@/components/header/HeaderDropdown.vue';
import DesktopAuthenticatedMenu from '@/components/header/nav-items/DesktopAuthenticatedMenu.vue';
import DesktopMainMenu from '@/components/header/nav-items/DesktopMainMenu.vue';
import NavSearch from '@/components/global/NavSearch.vue';
import ListItem from '@/components/controls/ListItem.vue';
import Pill from '@/components/controls/Pill.vue';
import { mapState } from 'vuex';

export default {
    components: {
        HeaderItem,
        HeaderDropdown,
        DesktopAuthenticatedMenu,
        DesktopMainMenu,
        NavSearch,
        ListItem,
        Pill
    },
    data() {
        return {
            searchMenu: false,
            moreMenu: false,
            profileMenu: false
        };
    },
    computed: {
        ...mapState('users', ['user']),
        ...mapState('messages', ['unreadCount'])
    },
    watch: {
        user() {
            this.profileMenu = false;
            this.onMenuChanged();
        }
    },
    methods: {
        onMenuChanged() {
            this.$emit(
                'showMenu',
                this.searchMenu || this.moreMenu || this.profileMenu
            );
        }
    },
    beforeDestroy() {
        this.$emit('showMenu', false);
    }
};
</script>
